import React, { useContext,useEffect, useState } from 'react';
import { Box, Typography, Stack, Button, Card, CardContent } from '@mui/material';
import { useNavigate, useParams , useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { postRequest } from '../../lib/api'; // update path as needed
import { AuthContext } from '../../authContext/context'; // update path as needed

const generatePassword = (length = 8) => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const special = '!@#$%^&*?';
  const all = upper + lower + digits + special;

  let password = '';
  password += upper[Math.floor(Math.random() * upper.length)];
  password += lower[Math.floor(Math.random() * lower.length)];
  password += digits[Math.floor(Math.random() * digits.length)];
  password += special[Math.floor(Math.random() * special.length)];

  for (let i = 4; i < length; i++) {
    password += all[Math.floor(Math.random() * all.length)];
  }

  return password
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');
};

const ResetPasswordForUser = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // user ID from route
  const authCtx = useContext(AuthContext);
  const [tempPassword, setTempPassword] = useState('');
  const [loading, setLoading] = useState(false);
    const location = useLocation()
    const type = location.state.key
    console.log(type)

  useEffect(() => {
    setTempPassword(generatePassword());
  }, []);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        id: id,
        password: tempPassword,
      };
      const response = await postRequest('private/resetUserPassword', payload, authCtx.token);
      if (response?.status === 200) {
        //toast.success('Password reset successfully!');
        if(type == 'user'){
          navigate('/users');
        }
        else{
            navigate('/solicitors');
        }
     
      } else {
        //toast.error(response?.message || 'Failed to reset password');
      }
    } catch (err) {
      //toast.error(err?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 3, p: 2 }}>

    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
      Reset Password
    </Typography>
      <Card variant="outlined" sx={{ backgroundColor: '#e8f8fa', borderLeft: '5px solid #007C91' }}>
        <CardContent>
          <Typography sx={{ mb: 1 }}>
            Please make a note of the temporary password which will be created for this user:
            <strong style={{ color: '#007C91' }}> {tempPassword} </strong>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            This should be changed when the user first logs in.
          </Typography>
        </CardContent>
      </Card>

      <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
        <Button variant="outlined" color="inherit" onClick={() => navigate(-1)} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" className='red-bg red-button text-capitalize'
  onClick={onSubmit} disabled={loading}>
          {loading ? 'Submitting...' : 'Proceed to change password'}
        </Button>
      </Stack>
    </Box>
  );
};

export default ResetPasswordForUser;
